/**
 * @generated SignedSource<<2b7e2350b520ecfe0048725504b749ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAIStagingRulePanel_AssignProductMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type addAIStagingRulePanel_AssignProductMutation$data = {
  readonly assignProductsToAIStagingRule: {
    readonly result: boolean;
  };
};
export type addAIStagingRulePanel_AssignProductMutation = {
  response: addAIStagingRulePanel_AssignProductMutation$data;
  variables: addAIStagingRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToAIStagingRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAIStagingRulePanel_AssignProductMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "addAIStagingRulePanel_AssignProductMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2a44bcf34023870bcc5fcf1fd3a27700",
    "id": null,
    "metadata": {},
    "name": "addAIStagingRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addAIStagingRulePanel_AssignProductMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToAIStagingRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "7166eae2de52293956021d05fa4be0a7";

export default node;
